import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestAddUserToKanBo (action) {
  const { loginType, loginName } = action.payload

  try {
    yield call(apiAction, 'AddUser', {
      loginType,
      loginName,
    })
  } catch (error) {
    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}
